import React from 'react';
import styled, { css } from 'styled-components';

export default function AccountSurveyForm({
    options, 
    handleClickRadio, 
    currDeleteReason, 
    isCheckedOption, 
    handleSubmit, 
    valid, 
    handleChangeEtc,
    handleClickCancel
}) {
    return (
        <>
        <AccountSurveyBlock>
            <AccountSurveyTitle>{'서비스를 탈퇴하시는 이유가 궁금해요👀'}</AccountSurveyTitle>
            <SurveyList>
                {options.map((option, index) => 
                <SurveyListItem key={`survey_option_no${option['no']}`}>
                    <SurveyOptionLabel>
                        <RadioInput type='radio' name="account_delete" id={option['data']} value={option} onClick={(e) => handleClickRadio(e, option['name']['ko'], option['no'])}/>
                        <RadioButton>
                            {currDeleteReason === option['name']['ko'] && isCheckedOption ? (
                            <RadioButtonInsideBlock>
                                <RadioButtonInside /> 
                            </RadioButtonInsideBlock>
                            ): null}
                        </RadioButton>
                        <SurveyOptionName>{option['name']['ko']}</SurveyOptionName>
                    </SurveyOptionLabel>
                </SurveyListItem>
                )}
                {currDeleteReason === '기타' ? (
                    <EtcInputBlock>
                       <EtcInput type='text' onChange={handleChangeEtc} placeholder='탈퇴 사유를 남겨주세요 :)'/>
                    </EtcInputBlock>
                ): null}
            </SurveyList>
        </AccountSurveyBlock>
        <BottomButtonBlock>
            {valid ? (
                <RightButton onClick={handleSubmit}>탈퇴하기</RightButton>
            ) : (
                <DisabledRightBtn>탈퇴하기</DisabledRightBtn>
            )}
            <LeftButton onClick={handleClickCancel}>취소</LeftButton>
        </BottomButtonBlock>
    </>
    )
}

const AccountSurveyBlock = styled.div`
    background-color: #F7F7F7;
    height: 100%;
    padding: calc(100vw * (30 / 375)) 0 calc(100vw * (30 / 375)) calc(100vw * (17 / 375));
`;

const AccountSurveyTitle = styled.h2`
    font-size: calc(100vw * (18 / 375));
    font-weight: 700;
`;

const SurveyList = styled.ul`
    display: flex;
    flex-direction: column;
    margin-top: calc(100vw * (16 / 375));
`;

const SurveyListItem = styled.li`
    margin-bottom: 0;
    &:not(:last-of-type) {
        margin-bottom: calc(100vw * (19 /375));
      }
`;

const RadioInput = styled.input`
    position: absolute;
    visibility: hidden;
`;

const SurveyOptionLabel = styled.label`
    display: flex;
    align-items: center;
    justify-content: flex-start;
`;

const RadioButton = styled.div`
    position: relative;
    display: flex;
    justify-content:center;
    align-items: center;
    width: calc(100vw * (21 / 375));
    height: calc(100vw * (21 / 375));
    border: 1.5px solid #8E8E93;
    border-radius: 50%;
    margin-right: calc(100vw * (11 / 375));
`;

const RadioButtonInsideBlock = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    justify-content:center;
    align-items: center;
`;

const RadioButtonInside = styled.span`
    display: block;
    background: #000;
    width: calc(100vw * (13 / 375));
    height: calc(100vw * (13 / 375));
    border-radius: 50%;
`;

const SurveyOptionName = styled.span`
    font-size: calc(100vw * (14 / 375));
    font-weight: 400;
    line-height: calc(100vw * (30.84 / 375));
`;

const EtcInputBlock = styled.div`
      margin-left: calc(100vw * (31 / 375));
`;

const EtcInput = styled.input`
    font-size: calc(100vw * (12 / 375));
    width: calc(100vw * (280 / 375));
    padding: calc(100vw * (9 / 375)) calc(100vw * (15 / 375));
    border-radius: calc(100vw * (3 / 375));
`;

const BottomButtonBlock = styled.div`
      display: flex;
      justify-content: center;
      width: 100%;
`;

const buttonStyle = css`
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: calc(100vw * (15 / 375));
    font-weight: 700;
    line-height: calc(100vw * (23 / 375));
    padding: calc(100vw * (15 / 375)) 0;
    width: 100%;
`;

const RightButton = styled.button`
    ${buttonStyle}
    background-color: #FFCF19;
`;

const DisabledRightBtn = styled.div`
    ${buttonStyle}
    background-color: #FFE688;
    color: #989898;
`;

const LeftButton = styled.button`
    ${buttonStyle}
    background-color: #707070;
    color: #fff;
`;